module.exports = __webpack_public_path__ + "img/tech_image_2_4.4e998aad.jpg";